import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class SpinnerComponent {
  isLoading = false;
  constructor(
    private readonly loader: LoaderService,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.loader.isLoading().subscribe({
      next: (loading: boolean) => {
        this.isLoading = loading;
        this.cd.detectChanges();
      },
    });
  }
}
